import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
import { formatToCashAllowNegative } from 'Common/FormHelper';
import { UserProfileFieldEnum } from 'Common/FieldEnum';

const LastTransactionDetails = props => {
  const { lastTransactionProfile } = props;

  const fullName = `${get(
    lastTransactionProfile,
    UserProfileFieldEnum.FirstName,
    ''
  )} ${get(lastTransactionProfile, UserProfileFieldEnum.LastName, '')}`;

  return fullName ? (
    <div className="last-transaction flex-shrink">
      <div className="title-label">Previous Student Balance</div>
      <div className="balance-container text-primary-bold">
        <div className="balance-student-name">{fullName}</div>
        <div className="balance-amount">
          <Icon name="dollar" />
          {formatToCashAllowNegative(lastTransactionProfile.Balance)}
        </div>
      </div>
    </div>
  ) : null;
};

LastTransactionDetails.propTypes = {
  lastTransactionProfile: PropTypes.object,
};

export default LastTransactionDetails;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/common/component/LastTransactionDetails.js